import { render, staticRenderFns } from "./GeneralSettingsTaxesWarning.vue?vue&type=template&id=5ace2a6a&"
import script from "./GeneralSettingsTaxesWarning.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsTaxesWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports